<script setup>
import imgToken from "@images/img-token.png";
import imgCoq from "@images/img-coq.png";
import imgKimbo from "@images/img-kimbo.png";
import { formatNumberValue } from "@/utils/helpers";

const seasonStats = ref();
const userRewards = ref([]);
const loading = ref(false);
const switchDisperseToHolders = ref(true);

onMounted(() => {
  fetchData();
});

const fetchData = async () => {
  try {
    loading.value = true;

    const p1 = getUserBattleRewards().then((response) => {
      console.log("User Rewards:", response);
      userRewards.value = response;
    });
    const p2 = getBattleSeasonStats().then((response) => {
      seasonStats.value = response;
    });

    await Promise.all([p1, p2]);
  } catch (error) {
    console.error("Error fetching user rewards:", error);
  } finally {
    loading.value = false;
  }
};

const formatPrizePool = (prize, token) => {
  const amount = Number(prize) || 0;
  return `${formatNumberValue(amount, 2)} ${token || ""}`;
};

const handleRewardClaimed = async () => {
  await fetchData();
};

const handleRewardClaimFailed = (error) => {
  console.error("Claim reward failed:", error);
};
</script>

<template>
  <v-card
    color="#2D2D2D"
    class="!tw-flex tw-flex-col !tw-rounded-2xl !tw-p-0"
    flat
    :loading="loading"
  >
    <v-card-title class="title-block">
      <div
        class="tw-z-[1] tw-text-2xl tw-gap-2 tw-flex tw-justify-center tw-items-center"
      >
        Battle Claims
      </div>
    </v-card-title>

    <v-card-text
      class="!tw-px-8 tw-flex tw-flex-col tw-h-full tw-max-h-full tw-overflow-hidden"
    >
      <div class="tw-text-center tw-text-xs tw-mt-4">
        Claim your pending NEXUS and other Tokens from Battle Seasons and Point
        Seasons!
      </div>

      <v-divider class="tw-my-4" :thickness="5" />

      <v-list
        class="tw-bg-transparent tw-p-0 claim-list tw-flex tw-flex-col tw-gap-4"
        density="compact"
        height="500"
      >
        <v-list-item
          class="tw-text-white"
          v-if="seasonStats && Object.keys(seasonStats).length"
        >
          <template v-slot:prepend>
            <v-avatar size="64">
              <v-img :src="seasonStats?.tokenIcon || imgToken" />
            </v-avatar>
          </template>
          <div class="tw-mb-3">
            <div>
              OPEN BATTLE SEASON:
              <span class="tw-font-bold">#{{ seasonStats?.season || 1 }}</span>
            </div>
            <div>
              TOKEN:
              <span class="tw-font-bold">
                {{ seasonStats?.tokenName || "SUJI" }}
              </span>
            </div>
            <div>
              PRIZE POOL:
              <span class="tw-font-bold">
                {{
                  formatPrizePool(
                    seasonStats?.totalPrize,
                    seasonStats?.tokenName,
                  )
                }}
              </span>
            </div>
          </div>
        </v-list-item>

        <user-reward
          v-if="userRewards && userRewards.length"
          v-for="(reward, index) in userRewards"
          :key="index"
          :reward="reward"
          :disperseToHolders="switchDisperseToHolders"
          @claimed="handleRewardClaimed"
          @claimFailed="handleRewardClaimFailed"
          class=""
        />

        <v-list-item class="tw-text-center tw-flex-auto" v-else>
          <div class="tw-font-bold">No current rewards to claim</div>
          <div>(hold 2 SIGILS to EARN for BATTLES)</div>
        </v-list-item>
      </v-list>

      <v-divider class="tw-my-4" :thickness="5" />

      <div class="tw-flex tw-items-center tw-justify-between">
        <span>
          Reward your Sigil holders!<br />
          Each claim, tip up to 5% of your reward split to all your holders.
        </span>
        <v-switch
          inset
          class="enable-reward-holders"
          color="surface"
          v-model="switchDisperseToHolders"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="postcss">
.enable-reward-holders {
  .v-selection-control--dirty {
    .v-switch__track {
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
    .v-selection-control__input {
      &::before {
        background: linear-gradient(90deg, #f3691f 0%, #f03822 100%) !important;
        box-shadow:
          0px 4px 4px rgba(0, 0, 0, 0.25),
          0px 4px 4px rgba(0, 0, 0, 0.25);
        filter: blur(20px);
        opacity: 1 !important;
      }
    }
    .v-switch__thumb {
      background: linear-gradient(90deg, #f3691f 0%, #f03822 100%) !important;
    }
  }
}
</style>
